import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const UploadCloud = () => (
  <ImageIcon src={Images.UploadCloud} alt="sh-logo-icon/" />
);

export default UploadCloud;
